import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
import store from '../_store';
import globals from '@/globals';

// Layouts
import Layout1 from '@/layout/Layout1';
import LayoutBlank from '@/layout/LayoutBlank';

Vue.use(Router);
Vue.use(Meta);

const router = new Router({
  base: '/',
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Layout1,
      children: [
        {
          path: '/',
          redirect: { name: 'HOME' }
        }
      ]
    },
    {
      path: '/',
      component: LayoutBlank,
      children: [
        {
          path: 'login',
          name: 'LOGIN',
          component: () => import('@/components/Login.vue'),
          meta: { name: 'LOGIN', requiresAuth: true }
        }
      ]
    },
    {
      path: '/',
      component: Layout1,
      children: [
        {
          path: 'client/list/',
          name: 'HOME',
          meta: { name: 'HOME', requiresAuth: true },
          component: () => import('@/components/ClientList')
        },
        {
          path: 'client/new',
          name: 'CLIENT_NEW',
          meta: { name: 'CLIENT_NEW', requiresAuth: true },
          component: () => import('@/components/ClientAdd')
        },
        {
          path: 'client/:id',
          name: 'CLIENT_EDIT',
          meta: { name: 'CLIENT_EDIT', requiresAuth: true },
          component: () => import('@/components/ClientView')
        },
        {
          path: '*',
          redirect: { name: 'HOME' }
        }
      ]
    }
  ]
});

router.afterEach((to, from, failure) => {
  if (failure) {
    console.log('failure', failure);
  }
  // On small screens collapse sidenav
  if (
    window.layoutHelpers &&
    window.layoutHelpers.isSmallScreen() &&
    !window.layoutHelpers.isCollapsed()
  ) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10);
  }
  // Scroll to top of the page
  globals().scrollTop(0, 0);
});

router.beforeEach((to, from, next) => {
  console.log('to', to);
  console.log('store state', store.state);
  console.log('store state auth', store.state.auth);
  console.log('store state auth logged in', store.state.auth.isLoggedIn);

  if (to.name === 'LOGIN' && !store.state.auth.isLoggedIn) {
    console.log('going to login');
    next();
  } else if (to.name === 'LOGIN' && store.state.auth.isLoggedIn) {
    next({ name: 'HOME' });
  } else if (to.meta.requiresAuth && !store.state.auth.isLoggedIn) {
    next({ name: 'LOGIN' });
  } else {
    next();
  }

  // Set loading state
  document.body.classList.add('app-loading');
  // Add tiny timeout to finish page transition
  setTimeout(() => next(), 10);
});

export default router;
